// crewbit-admin/src/components/money/DisputeBanner.tsx
//
// Spec: §InvoiceDetail.7.2 dispute strip. Visible only when is_disputed AND
// dispute_status NOT IN ('won','lost'). Tap routes to deferred dispute detail.

import { AlertTriangle, ChevronRight } from 'lucide-react';
import { palette, spacing, typography, transition } from '../../styles/tokens';
import { formatMoney } from '../../lib/money';
import type { Invoice } from '../../types';

interface Props {
  invoice: Invoice;
  onTap?: () => void;
}

export function DisputeBanner({ invoice, onTap }: Props) {
  const open = !!invoice.is_disputed && invoice.dispute_status !== 'won' && invoice.dispute_status !== 'lost';
  if (!open) return null;

  const reason = invoice.dispute_reason ?? 'Reason not provided';
  const amount = invoice.dispute_amount != null ? formatMoney(invoice.dispute_amount) : null;

  return (
    <button
      onClick={onTap}
      style={{
        display: 'flex', alignItems: 'center', gap: spacing.sm,
        width: '100%', textAlign: 'left',
        padding: `${spacing.sm}px ${spacing.md}px`,
        background: palette.redWash, border: `1px solid ${palette.red}`,
        borderRadius: 12, marginBottom: spacing.md,
        cursor: onTap ? 'pointer' : 'default', fontFamily: 'inherit',
        transition: `background ${transition.fast}`,
      }}
    >
      <AlertTriangle size={18} color={palette.red} strokeWidth={2} />
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: typography.size.caption, fontWeight: typography.weight.semibold, color: palette.red }}>
          Dispute open{amount ? ` — ${amount}` : ''}
        </div>
        <div style={{ fontSize: typography.size.micro, color: palette.g700, marginTop: 2 }}>
          {reason}
        </div>
      </div>
      {onTap && <ChevronRight size={16} color={palette.red} />}
    </button>
  );
}
